import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Simple authentication check - you can enhance this
  let isAuthenticated = localStorage.getItem('authToken');
  
  // Auto-set admin token for development if no token exists
  if (!isAuthenticated) {
    localStorage.setItem('authToken', 'test-admin-token');
    isAuthenticated = 'test-admin-token';
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
